/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 2:29:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useAPIMutation, APISERVICEPATHS, useAPIForm, UseAPIFormSpec } from "lib/api";
import { NumberingSequence, NumberingSequenceValidationSchema } from "lib/schemas";

const numberingSequencesAPIServicePath = APISERVICEPATHS.numberingSequences;

interface UseNumberingSequenceAPIFormSpec {
  numberingSequenceId: NumberingSequence["id"];
  numberingSequenceDefault: NumberingSequence;
  updateNumberingSequenceFromAPICallback: UseAPIFormSpec<NumberingSequence>["setAPIFormResponse"];
}

const useNumberingSequenceAPIForm = ({
  numberingSequenceId,
  numberingSequenceDefault,
  updateNumberingSequenceFromAPICallback,
}: UseNumberingSequenceAPIFormSpec) => {
  const useAPIFormReturn = useAPIForm({
    apiServicePath: numberingSequencesAPIServicePath,
    apiFormDataValidationSchema: NumberingSequenceValidationSchema,
    apiFormDefaultValues: numberingSequenceDefault,
    apiInitialFetchId: numberingSequenceId,
    primaryKey: "id",
    setAPIFormResponse: updateNumberingSequenceFromAPICallback,
  });

  return useAPIFormReturn;
};

export const useNumberingSequenceAPI = () => ({
  useMutate: () =>
    useAPIMutation<NumberingSequence>({
      apiServicePath: numberingSequencesAPIServicePath,
    }),
  useNumberingSequenceAPIForm,
});
